// extracted by mini-css-extract-plugin
module.exports = {"btnCustomized":"PrintoutButton_btnCustomized__3iOeE","printoutDropdown":"PrintoutButton_printoutDropdown__3ej42"};